/* cro-restock.js
 *
 * The branded "Notify me when it's back" modal (Klaviyo Back-in-Stock for email, Postscript for SMS).
 *
 * WHY IT IS A SHARED ASSET: it used to live inline inside sections/main-product.liquid, which meant
 * only the PRODUCT PAGE could open it. Sold-out sizes in the quick-add tray on product cards, which
 * appear on the homepage carousels, collection pages and the recommendations carousel, had no way to
 * reach it. Now any surface can call:
 *
 *     window.fstRestock.open({ variantId: 123, productName: 'Jesus Saves Patchwork Hoodie' })
 *
 * Called with NO arguments it falls back to reading the page (the [name="id"] input and the h1),
 * which is exactly what the product page did before, so PDP behaviour is unchanged.
 *
 * Styling lives in assets/cro-product.css (.fst-restock*), already loaded sitewide.
 */
(function(){
  if (window.fstRestock) return;
  // Klaviyo public site ID (the same one klaviyo.js loads with). It used to be declared inside main-product's own
  // script, but Shopify scopes each section's script, so once this modal moved into this shared asset (around Aug 21)
  // the email submit threw "RESTOCK_KLAVIYO_COMPANY is not defined" and NO restock signup reached Klaviyo.
  // Found 2026-09-28 (Klaviyo: 392 signups in July, last one Aug 21, zero in September). Keep it declared here.
  var RESTOCK_KLAVIYO_COMPANY = 'UGE4P7';
  /* Postscript Back-in-Stock handoff.
   * REWRITTEN 2026-08-23 after it started silently doing nothing. The old version clicked the
   * teaser bubble and returned false if it was not in the DOM yet, and the caller had ALREADY
   * closed our modal, so the shopper watched everything vanish and nothing open.
   * Diagnosis on the live site: the SDK now exposes window.postscript.backInStock.open() (works on
   * desktop), but the teaser injects LATE, and on mobile the SDK's widget iframe sometimes never
   * mounts at all, so no client-side call can open it (a Postscript-side failure).
   * So this version: tries the official API, then the teaser click, VERIFIES the modal actually
   * appeared before claiming success, retries for up to 6s to ride out slow SDK boots, and reports
   * failure to the caller instead of pretending. The caller keeps our modal open and points the
   * shopper at email, which works regardless of Postscript's state. */
  function tryOpenPostscriptOnce(){
    try { if (window.postscript && window.postscript.backInStock && window.postscript.backInStock.open) window.postscript.backInStock.open(); } catch(e){}
    var t = document.querySelector('#ps-bis-widget-bubble__close-text')
         || document.querySelector('#ps-bis-widget-bubble__close-container')
         || document.querySelector('[id^="ps-bis-widget-bubble"]');
    if (t) { try { t.click(); } catch(e){} }
  }
  /* Success = ANY visible Postscript surface, not just the desktop modal ids. The first version
   * only checked [id^="ps-bis-widget-modal"], which is what the DESKTOP widget renders. The mobile
   * widget mounts under its own ids (ps-mobile-widget*) or as the ps__widget iframe going
   * full-screen, so on a phone the widget could open while our check still said "not loaded" and
   * the red fallback printed underneath it. */
  function psSurfaceVisible(){
    var sels = ['[id^="ps-bis-widget-modal"]', '[id^="ps-mobile-widget"]', '[id^="ps-desktop-widget"]', '#ps__widget'];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      for (var j = 0; j < els.length; j++) {
        var r = els[j].getBoundingClientRect ? els[j].getBoundingClientRect() : null;
        if (r && r.width > 40 && r.height > 40) return true;
      }
    }
    var root = document.getElementById('ps__bis_container_root');
    if (root) { var rr = root.getBoundingClientRect(); if (rr.width > 40 && rr.height > 120) return true; }
    return false;
  }
  function openPostscriptBIS(done){
    var started = Date.now();
    (function attempt(){
      if (psSurfaceVisible()) { done(true); return; }
      tryOpenPostscriptOnce();
      setTimeout(function(){
        if (psSurfaceVisible()) { done(true); return; }
        if (Date.now() - started > 8500) { done(false); return; }
        setTimeout(attempt, 500);
      }, 650);
    })();
  }
  /* If their widget mounts AFTER we already gave up, clean up after ourselves: hide our fallback
   * note and close our modal so the shopper does not find a stale error sitting behind it. Watches
   * for 25s past the timeout, then stops. */
  function watchForLatePostscript(wrap){
    var until = Date.now() + 25000;
    var t = setInterval(function(){
      if (psSurfaceVisible()) {
        clearInterval(t);
        var err = wrap.querySelector('[data-fst-restock-err]');
        if (err) err.hidden = true;
        closeRestockModal();
        return;
      }
      if (Date.now() > until) clearInterval(t);
    }, 600);
  }
  var CTX = {};   // set by open(); empty means "read the page", i.e. the product page
  function restockVariantId(){
    if (CTX.variantId) return String(CTX.variantId);
    var el = document.querySelector('[name="id"]'); return el ? (el.value||'').trim() : '';
  }
  function restockProductName(){
    if (CTX.productName) return String(CTX.productName).slice(0,70);
    var h = document.querySelector('h1.product-title, .product-text h1, h1[class*="product"]') || document.querySelector('h1');
    return h ? (h.textContent||'').trim().slice(0,70) : 'this item';
  }
  /* 2026-10-20: Postscript's text signup only exists on a PRODUCT PAGE, for the size in that page's URL. From a
   * product card (collections, homepage, the recommendations row) it could never open: the shopper saw
   * "Opening text signup..." for 8s and then an error, and on a product page the recommendations row would have
   * signed them up for the PAGE's product instead. So when the modal is for another variant than the product page
   * we are on, "Get a text" hops to that variant's product page with #fst-text, and boot() there opens
   * Postscript's own popup (their phone field, consent text and reply-Y confirmation stay theirs). */
  function pageVariantId(){
    if (!/\/products\//.test(location.pathname)) return '';
    var el = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
    return el ? String(el.value||'').trim() : '';
  }
  function textNeedsHop(){
    var id = CTX.variantId ? String(CTX.variantId) : '';
    return !!id && id !== pageVariantId();
  }
  function hopToTextSignup(){
    var id = String(CTX.variantId);
    var go = function(url){ location.href = url.split('#')[0] + '#fst-text'; };
    var fallback = setTimeout(function(){ go('/variants/' + id); }, 4000);
    fetch('/variants/' + id, { credentials: 'same-origin' }).then(function(r){
      clearTimeout(fallback); go(r.ok && r.url ? r.url : '/variants/' + id);
    }).catch(function(){ clearTimeout(fallback); go('/variants/' + id); });
  }
  function textFailed(wrap){
    var err = wrap.querySelector('[data-fst-restock-err]');
    if (err) { err.textContent = 'Text signup did not load. Enter your email above and we will still reach you the moment it is back.'; err.hidden = false; }
    watchForLatePostscript(wrap);
  }
  function closeRestockModal(){
    var m = document.getElementById('fst-restock'); if(!m) return;
    m.classList.remove('is-open'); m.setAttribute('hidden','');
    document.documentElement.style.overflow='';
  }
  function buildRestockModal(){
    var existing = document.getElementById('fst-restock'); if (existing) return existing;
    var wrap = document.createElement('div');
    wrap.id = 'fst-restock'; wrap.className = 'fst-restock'; wrap.setAttribute('hidden','');
    wrap.innerHTML =
      '<div class="fst-restock__overlay" data-fst-restock-close></div>'+
      '<div class="fst-restock__dialog" role="dialog" aria-modal="true" aria-label="Notify me when it is back">'+
        '<button class="fst-restock__x" type="button" aria-label="Close" data-fst-restock-close>&times;</button>'+
        '<div data-fst-restock-view="form">'+
          '<h2 class="fst-restock__title">Notify me when it&rsquo;s back</h2>'+
          '<p class="fst-restock__sub" data-fst-restock-sub>We&rsquo;ll let you know the moment it&rsquo;s back in stock.</p>'+
          '<form class="fst-restock__form" data-fst-restock-form novalidate>'+
            '<input type="email" class="fst-restock__input" data-fst-restock-email placeholder="you@email.com" autocomplete="email" required>'+
            '<button type="submit" class="fst-restock__btn" data-fst-restock-submit>Email me when it&rsquo;s back</button>'+
          '</form>'+
          '<p class="fst-restock__err" data-fst-restock-err hidden></p>'+
          '<button type="button" class="fst-restock__alt" data-fst-restock-text>Prefer a text? Get a text instead &rarr;</button>'+
        '</div>'+
        '<div data-fst-restock-view="success" hidden>'+
          '<div class="fst-restock__check"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg></div>'+
          '<h2 class="fst-restock__title">You&rsquo;re on the list.</h2>'+
          '<p class="fst-restock__sub">We&rsquo;ll email you the moment it&rsquo;s back in stock.</p>'+
          '<button type="button" class="fst-restock__alt" data-fst-restock-text>Want a text too? Get a text &rarr;</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(wrap);
    wrap.querySelectorAll('[data-fst-restock-close]').forEach(function(el){ el.addEventListener('click', closeRestockModal); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeRestockModal(); });
    wrap.querySelectorAll('[data-fst-restock-text]').forEach(function(b){ b.addEventListener('click', function(){
      // Do NOT close our modal until Postscript's has actually appeared. If it never does (their
      // mobile widget can fail to mount), the shopper stays here with a working email path and an
      // explanation instead of a dead tap.
      if (b.dataset.busy) return;
      b.dataset.busy = '1';
      var orig = b.innerHTML;
      b.innerHTML = 'Opening text signup&hellip;';
      if (textNeedsHop()) { hopToTextSignup(); return; }
      openPostscriptBIS(function(ok){
        delete b.dataset.busy;
        b.innerHTML = orig;
        if (ok) { closeRestockModal(); return; }
        textFailed(wrap);
      });
    }); });
    wrap.querySelector('[data-fst-restock-form]').addEventListener('submit', function(e){ e.preventDefault(); submitRestockEmail(wrap); });
    return wrap;
  }
  function submitRestockEmail(wrap){
    var emailEl = wrap.querySelector('[data-fst-restock-email]');
    var errEl = wrap.querySelector('[data-fst-restock-err]');
    var btn = wrap.querySelector('[data-fst-restock-submit]');
    var email = (emailEl.value||'').trim();
    errEl.hidden = true;
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { errEl.textContent='Please enter a valid email.'; errEl.hidden=false; return; }
    var variant = restockVariantId();
    if (!variant) { errEl.textContent='Please choose your options first.'; errEl.hidden=false; return; }
    btn.disabled = true; btn.textContent = 'Adding you…';
    var body = { data:{ type:'back-in-stock-subscription', attributes:{
      profile:{ data:{ type:'profile', attributes:{ email: email } } }, channels:['EMAIL']
    }, relationships:{ variant:{ data:{ type:'catalog-variant', id:'$shopify:::$default:::'+variant } } } } };
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='+RESTOCK_KLAVIYO_COMPANY, {
      method:'POST', headers:{ 'Content-Type':'application/json', 'revision':'2024-10-15' }, body: JSON.stringify(body)
    }).then(function(res){
      if (!res.ok) throw new Error('status '+res.status);
      wrap.querySelector('[data-fst-restock-view="form"]').hidden = true;
      wrap.querySelector('[data-fst-restock-view="success"]').hidden = false;
      try { if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track','Subscribed to Back in Stock (email)', { product: restockProductName() }]); } catch(e){}
    }).catch(function(){
      errEl.textContent='Something went wrong. Please try again.'; errEl.hidden=false;
      btn.disabled=false; btn.innerHTML='Email me when it&rsquo;s back';
    });
  }
  function openRestockModal(opts){
    CTX = opts || {};
    var m = buildRestockModal();
    m.querySelector('[data-fst-restock-view="form"]').hidden = false;
    m.querySelector('[data-fst-restock-view="success"]').hidden = true;
    var err = m.querySelector('[data-fst-restock-err]'); if(err) err.hidden = true;
    var sub = m.querySelector('[data-fst-restock-sub]'); if(sub) sub.textContent = 'We’ll let you know the moment '+restockProductName()+' is back in stock.';
    var submit = m.querySelector('[data-fst-restock-submit]'); if(submit){ submit.disabled=false; submit.innerHTML='Email me when it&rsquo;s back'; }
    m.removeAttribute('hidden'); void m.offsetWidth; m.classList.add('is-open');
    document.documentElement.style.overflow='hidden';
    var inp = m.querySelector('[data-fst-restock-email]'); if(inp) setTimeout(function(){ try{ inp.focus(); }catch(e){} }, 60);
  }
  function wireRestockClick(){
    var btn = document.querySelector('[data-main-product-add-to-cart]') || document.querySelector('.add-to-cart');
    if (!btn || btn.dataset.fstRestockWired) return;
    btn.dataset.fstRestockWired = '1';
    btn.addEventListener('click', function(e){
      if (!btn.classList.contains('fst-soldout')) return; // available -> normal add-to-cart
      e.preventDefault(); e.stopImmediatePropagation();    // sold out -> open the branded restock modal
      openRestockModal();
    }, true);
  }
  function openTextOnArrival(){
    if (location.hash !== '#fst-text' || !/\/products\//.test(location.pathname)) return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch(e){}
    var started = Date.now();
    (function waitForSdk(){
      var ready = window.postscript && window.postscript.backInStock && window.postscript.backInStock.open;
      if (!ready && Date.now() - started < 10000) { setTimeout(waitForSdk, 300); return; }
      openPostscriptBIS(function(ok){
        if (ok) return;
        // Back in stock since they tapped? Then the page's own Add to cart is the answer; say nothing.
        if (!document.querySelector('[data-main-product-add-to-cart].fst-soldout, .add-to-cart.fst-soldout')) return;
        openRestockModal();
        textFailed(document.getElementById('fst-restock'));
      });
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openTextOnArrival); else openTextOnArrival();
  window.fstRestock = {
    open: openRestockModal,
    close: closeRestockModal,
    wirePdpButton: wireRestockClick
  };
})();
